import React, { useState, useEffect } from 'react';
import apiFetch from '@wordpress/api-fetch';
import { renderInputRow } from '../../../utils/renderInputRow';
import { Button } from '../../../components/ui/index.jsx';
import { useToast } from '../../../components/ui/Toast.jsx';

const NewUserRegistrationTab = () => {
    const toast = useToast();
    const [originalNewRegistrationSettings, setOriginalNewRegistrationSettings] = useState({});
    const [newRegistrationSettings, setNewRegistrationSettings] = useState({});
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        const global = window.BPSFW_GLOBAL_OPTIONS || {};
        setNewRegistrationSettings(global);
        setOriginalNewRegistrationSettings(global);
    }, []);

    const handleSave = () => {
        const changedData = Object.fromEntries(
            Object.entries(newRegistrationSettings).filter(([key, value]) => originalNewRegistrationSettings[key] !== value)
        );
        if (Object.keys(changedData).length === 0) {
            toast.info('No changes detected.');
            return;
        }
        setLoading(true);
        apiFetch({ path: '/wp/v2/settings', method: 'POST', data: changedData })
            .then(() => {
                toast.success('New user registration settings saved!');
                window.BPSFW_GLOBAL_OPTIONS = { ...(window.BPSFW_GLOBAL_OPTIONS || {}), ...newRegistrationSettings };
                setOriginalNewRegistrationSettings(newRegistrationSettings);
            })
            .catch((err) => {
                console.error('Error saving new user registration settings:', err);
                toast.error('Error saving new user registration settings.');
            })
            .finally(() => setLoading(false));
    };

    const updateNewRegistrationSetting = (key, value) => {
        setNewRegistrationSettings({ ...newRegistrationSettings, [key]: value });
    };

    return (
        <div className="plugin-notification-setting-tab">
            {loading && (
                <div className="bpsfw-overlay-loader">
                    <div className="bpsfw-loader-box">
                        <div className="bpsfw-spinner"></div>
                        <span className="bpsfw-loader-text">Saving changes…</span>
                    </div>
                </div>
            )}

            {/* ── Approval Settings ── */}
            <div className="bpsfw-section-card">
                <div className="bpsfw-section-header">
                    <div className="bpsfw-section-icon">✅</div>
                    <div>
                        <div className="bpsfw-section-title">Approval Settings</div>
                        <div className="bpsfw-section-subtitle">Control how new registrations are handled</div>
                    </div>
                </div>
                <div className="bpsfw-section-body">
                    {renderInputRow(
                        'Manual Approval Required',
                        'bpsfw_approve_registration',
                        'checkBox', [],
                        'Require admin approval before new users can access the store',
                        '', newRegistrationSettings, updateNewRegistrationSetting
                    )}
                    {renderInputRow(
                        'Pending Approval Message',
                        'bpsfw_pending_account_approval',
                        '', [], '', '', newRegistrationSettings, updateNewRegistrationSetting,
                        <p className="description">Shown to users whose account is waiting for approval</p>
                    )}
                    {renderInputRow(
                        'Password Reset Pending Message',
                        'bpsfw_pending_reset_password_approval',
                        '', [], '', '', newRegistrationSettings, updateNewRegistrationSetting,
                        <p className="description">Shown to users whose password reset is pending approval</p>
                    )}
                </div>
            </div>

            {/* ── Rejection Email ── */}
            <div className="bpsfw-section-card">
                <div className="bpsfw-section-header">
                    <div className="bpsfw-section-icon">🚫</div>
                    <div>
                        <div className="bpsfw-section-title">Account Rejection Email</div>
                        <div className="bpsfw-section-subtitle">Email sent to users when their registration is denied</div>
                    </div>
                </div>
                <div className="bpsfw-section-body">
                    {renderInputRow(
                        'Enable Rejection Email',
                        'bpsfw_account_disale_email',
                        'checkBox', [],
                        'Notify users by email when their registration is rejected',
                        '', newRegistrationSettings, updateNewRegistrationSetting
                    )}
                    {renderInputRow('Rejection Email Subject', 'bpsfw_reject_email_subject', '', [], '', '', newRegistrationSettings, updateNewRegistrationSetting, '', true)}
                    {renderInputRow('Rejection Email Message', 'bpsfw_reject_email_message', 'textArea', [], '', '', newRegistrationSettings, updateNewRegistrationSetting, '', true)}
                </div>
            </div>

            {/* ── Approval Email ── */}
            <div className="bpsfw-section-card">
                <div className="bpsfw-section-header">
                    <div className="bpsfw-section-icon">🎉</div>
                    <div>
                        <div className="bpsfw-section-title">Account Approval Email</div>
                        <div className="bpsfw-section-subtitle">Email sent to users when their registration is approved</div>
                    </div>
                </div>
                <div className="bpsfw-section-body">
                    {renderInputRow(
                        'Enable Approval Email',
                        'bpsfw_account_approve_email',
                        'checkBox', [],
                        'Notify users by email when their registration is approved',
                        '', newRegistrationSettings, updateNewRegistrationSetting
                    )}
                    {renderInputRow('Approval Email Subject', 'bpsfw_approve_email_subject', '', [], '', '', newRegistrationSettings, updateNewRegistrationSetting, '', true)}
                    {renderInputRow('Approval Email Message', 'bpsfw_approve_email_message', 'textArea', [], '', '', newRegistrationSettings, updateNewRegistrationSetting, '', true)}
                </div>
            </div>

            <div className="bpsfw-save-row">
                <Button variant="primary" onClick={handleSave}>Save Changes</Button>
            </div>
        </div>
    );
};

export default NewUserRegistrationTab;
